/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */
import { LanguagePage, PageTitles } from '../../interfaces/types';
import { MetadataContainer } from '../container';
import { EntityMetadata } from '../entityMetadata';

interface Config {
  name: PageTitles;
  language?: LanguagePage;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function Entity<T extends new(...args: any[]) => {}>(
  configuration: Config
) {
  return function(constructor: T) {
    constructor.prototype.entity_name = configuration.name;

    const col = MetadataContainer.columns[constructor.name];
    MetadataContainer.entityMetadataList[configuration.name] =
      new EntityMetadata({
        entity: constructor,
        language: configuration.language,
        columns: !col ? [] : [...col],
      });

    delete MetadataContainer.columns[constructor.name];
  };
}
